
import './style.scss'
import DashboardSideMenu from '../../sections/dashboardSideMenu/DashboardSideMenu';
import DashboardHeader from '../../sections/dashboardHeader/DashboardHeader';
// import DashboardContentArea from '../../sections/dashboardContentArea/DashboardContentArea';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { userStateData } from '../../data/userStateData';
import { interactionConnector } from '../../server/connector/interactionConnector';
import { setDataLoadRequestFinished } from '../../redux/reducers/userSlice';
// import DashboardInstructorContentArea from '../../sections/dashboardInstructorContentArea/DashboardInstructorContentArea';
import DashboardInstructorSideMenu from '../../sections/dashboardInstructorSideMenu/DashboardInstructorSideMenu';
import { setSubPage } from '../../redux/reducers/dashboardSlice';
import { DashboardSubPages } from '../../types/types';
import DashboardReviewsContentArea from '../../sections/dashboardReviewsContentArea/DashboardReviewsContentArea';
import { PAGE_URLS } from '../../constants/hrefLinks';

function DashboardReviews() {
	const loginChecked: boolean = useAppSelector(state => state.user.loginChecked)
	const dispatch = useAppDispatch()

	useEffect(() => {
		// set subpage for side menu highlighting
		dispatch(setSubPage(DashboardSubPages.REVIEWS))
		// check if log in has been checked and confirmed in App.tsx
		if (loginChecked == true) {
			// confirm a user is logged in
			if (userStateData.loggedIn == false) {
				window.location.replace(PAGE_URLS.SEARCH)
			} else {
				// Load user data such as interactions data
				loadProfileData()
			}
		}
	}, [loginChecked])

	const loadProfileData = () => {
		if (interactionConnector.requestInProgress) {
			console.log('[Dashboard] - loadProfileData() called while requestInProgress')
		} else {
			// Check if user has interactions to load
			// console.log('userStateData.getInteractionIds() = ', userStateData.getInteractionIds())
			if (userStateData.isAnInstructor()) {
				interactionConnector.performGetInstructorInteractionsRequest(userStateData.getId()).then((requestStatus) => {
					if (!requestStatus) {
						console.log('WARNING - [Dashboard] - performGetCustomerInteractionsRequest() failed')
						dispatch(setDataLoadRequestFinished(true))
					}
					else {
						dispatch(setDataLoadRequestFinished(true))
					}
				})
			} else {
				interactionConnector.performGetCustomerInteractionsRequest(userStateData.getId()).then((requestStatus) => {
					if (!requestStatus) {
						console.log('WARNING - [Dashboard] - performGetCustomerInteractionsRequest() failed')
						dispatch(setDataLoadRequestFinished(true))
					}
					else {
						if (userStateData.likedInstructors.length > 0) {
							interactionConnector.performGetFavInstructorRequest(userStateData.likedInstructors.join(",")).then((secondResponseStatus) => {
								if (!secondResponseStatus) {
									console.log('WARNING - [Dashboard] - performGetFavInstructorRequest() failed')
								}
								dispatch(setDataLoadRequestFinished(true))
							})
						} else {
							dispatch(setDataLoadRequestFinished(true))
						}
					}
				})
			}
		}
	}

	return (
		<div className='dashboard-wrap'>
			{loginChecked &&
				<>
					{userStateData.isAnInstructor() ? <DashboardInstructorSideMenu /> : <DashboardSideMenu />}
					<div
						className='dashboard-content-wrap'
					>
						<DashboardHeader title='Dashboard - Reviews' />
						{userStateData.isAnInstructor() ? <DashboardReviewsContentArea /> : <DashboardReviewsContentArea />}
					</div>
				</>
			}
		</div>
	)
}

export default DashboardReviews
